import { vars } from "@imwebme/clay-token";
import { useEffect, useState } from "react";
import { Flex } from "../utilities";
import { useTabContext } from "./Tab.provider";
import { getTabARIA } from "./Tab.utils";

export const TabsIndicator = () => {
  const tabContext = useTabContext();
  const [activeTabOffset, setActiveTabOffset] = useState({ left: 0, width: 0 });
  const attr = getTabARIA({
    index: tabContext.activeIndex,
    uniqueId: tabContext.uniqueId,
  });

  useEffect(() => {
    const activeTab = document?.querySelector<HTMLButtonElement>(`#${CSS.escape(attr.tab.id)}`);

    const isActiveTabHasDot = activeTab?.querySelector("[data-clay-dot-badge]");

    if (!activeTab) return;

    const DOT_AREA_WIDTH = 10;

    setActiveTabOffset({
      left: activeTab?.offsetLeft || 0,
      width:
        (isActiveTabHasDot && !tabContext.fullWidth
          ? activeTab.offsetWidth - DOT_AREA_WIDTH
          : activeTab.offsetWidth) || 0,
    });
  }, [attr.tab.id, tabContext.fullWidth]);

  return (
    <Flex
      position="absolute"
      bottom={0}
      left={activeTabOffset.left ?? 0}
      width={activeTabOffset.width ?? "50px"}
      height={2}
      backgroundColor={vars.semantic.color.focus}
      transition="left 0.3s, width 0.3s"
    />
  );
};
